import isUnscheduledShift from '@sdk/shifts/utils/isUnscheduledShift';

import reportDynamicFieldComponentUrl from './reportDynamicFieldComponent.html';
import reportDynamicFieldContentUrl from './reportDynamicFieldContent.html';

export default {
  bindings: {
    schema: '<',
    data: '<',
    type: '<',
    eval: '<',
    showDurationsAsDecimals: '<',
    showTooltipIfOverflown: '<',
  },
  controllerAs: 'ctrl',
  controller: class ReportDynamicFieldCtrl {
    contentTemplate = reportDynamicFieldContentUrl;

    constructor(toTimeFilter, Utils) {
      'ngInject';

      Object.assign(this, { toTimeFilter, Utils });
    }

    $onInit() {
      this.userLink = `${this.type}-userLink`;
      this.positionLink = `${this.type}-positionLink`;
      this.locationLink = `${this.type}-locationLink`;
    }

    displayTime() {
      return this.data[this.type] && !isUnscheduledShift(this.data)
        ? this.toTimeFilter(this.data[this.type])
        : this.eval(this.schema[this.type].emptyValue);
    }
  },
  templateUrl: reportDynamicFieldComponentUrl,
};
